/**
 * Tools pages — English (for t('tools.…'))
 */
export default {
	dailyEnergy: {
		meta: {
			title: "Daily Energy - Seerq",
			keywords: "daily energy,today fortune,bazi fortune",
			description:
				"Check your daily energy and personalized life guidance, including daily, Month, and Year fortune details.",
		},
		breadcrumb: "Daily Energy",
		back: "Back",
		periodTabs: {
			day: "Daily",
			month: "Month",
			year: "Year",
		},
		profile: {
			mine: "Mine ›",
			default: "My Profile",
			selectHint: "Tap a profile to switch and return to Daily Energy",
			current: "Active",
			switchFailed: "Failed to switch profile. Please try again.",
		},
		load: {
			loading: "Loading fortune...",
		},
		error: {
			title: "Unable to load today's fortune",
			retry: "Reload",
			loadFailed: "Unable to load Daily Energy",
			dateSwitchFailed: "Failed to switch date",
			monthLoadFailed: "Failed to load Month fortune",
			yearLoadFailed: "Failed to load Year fortune",
		},
		gauge: {
			ariaLabel: "Daily Energy {score} points",
		},
		todayEnergy: "Daily Energy",
		question: "When will my love luck peak?",
		consult: "Ask Now",
		viewCalendar: "View Almanac →",
		tryLabel: "Try this:",
		slowLabel: "Take it slow:",
		actionAdvice: "Action Advice",
		meditation: {
			heading: "Listen to a soothing healing track",
			viewMore: "Explore",
			playSoon: "Coming up: {name}",
		},
		toast: {
			consultPending: "Consultation coming soon",
			calendarPending: "Almanac coming soon",
			meditationPending: "Meditation space coming soon",
			sharePending: "Share coming soon",
		},
		share: "Share",
		sharePanel: {
			cardTitle: "Energy Card",
			shareTo: "Share to",
			saveImage: "Save Image",
			saving: "Saving…",
			generating: "Generating energy card…",
			generateFailed: "Failed to generate share image. Please try again.",
			saveSuccess: "Image saved",
			saveFailed: "Failed to save. Please try again.",
			copyLink: "Copy Link",
			copySuccess: "Link copied",
			copyFailed: "Failed to copy. Please try again.",
			scanTitle: "Scan to see your fortune",
			scanDesc: "Plan your life with ease",
			defaultShareText: "Check out my daily energy!",
			needDayFortune: "Please open daily fortune first before sharing",
		},
		pc: {
			periodComingSoon: "Month fortune coming soon",
			periodComingSoonDesc:
				"Month fortune for PC is under development. Please check daily or Year fortune for now.",
			sidebar: {
				ariaLabel: "Daily energy sidebar",
				comingSoon: "Coming soon",
				ai: {
					cardTitle: "AI Chat",
					badge: "World's First AI Companion—MasterS",
					title: "Master S — Your AI Fortune Companion",
					desc: "Deep conversation, fortune reading, and life guidance whenever you need it.",
					tags: {
						chat: "Deep Chat",
						fortune: "Destiny Insights",
						life: "Life Advice",
					},
					cta: "Ask Now",
				},
				expert: {
					title: "Want year-round support?",
					desc: "Senior consultants provide personalized Year fortune guidance.",
				},
				reports: {
					title: "In-depth Reports",
				},
			},
		},
		dateStrip: {
			ariaLabel: "Select date",
		},
		card: {
			createProfile: "Create your energy profile",
			unlock: "Unlock Fortune",
			todayEnergy: "Daily Energy",
			energyStatus: "Energy Status",
			greetingWithName: "{name}, may you move with the flow",
			greetingDefault: "See the moment, move with the flow",
			levels: {
				abundant: "Abundant",
				stable: "Stable",
				charging: "Charging",
				rest: "Resting",
			},
		},
		month: {
			deepReport: "In-depth Reports",
			reportFallback: ["$", "♡", "☯", "★"],
		},
		year: {
			YearAdvice: "Year advice:",
			starRating: "{score} stars",
			teacherFallback: "M",
			experience: "Experience",
			rating: "Rating",
			consultCount: "Consultations",
		},
		fallback: {
			unlockText: "Unlock full fortune",
			practicalAdviceTitle: "Today's Practical Advice",
			lifeTipsTitle: "Life Reminders",
			profileLabel: "My Profile",
			monthSummaryTitle: "Month Summary",
			weeklyTitle: "Weekly Advice",
			monthTitle: "This Month's Advice",
			yearSummaryTitle: "Year Summary",
			riskTitle: "Key Risks & Opportunities",
			goodAdviceTitle: "Lucky Advice",
			consultButton: "Ask Now",
			unlockEnergy: "Unlock full energy guidance",
		},
	},
	huangli: {
		meta: {
			title: "Almanac - Professional Calendar",
			keywords: "almanac,tongsheng,yi-ji,date selection,five elements",
			description:
				"Professional Chinese almanac with yi-ji, five elements, bazi, and date selection.",
			zeriTitle: "Date Selection",
			zeriDescription: "Find auspicious dates for your plans with the almanac.",
			zeriListTitle: "Date Selection Results",
			zeriListDescription: "Almanac date selection results",
			detailTitle: "Almanac Details",
			detailDescription: "Detailed yi-ji, clashes, auspicious and inauspicious spirits.",
		},
		breadcrumb: "Chinese Almanac",
		share: "Share",
		sharePanel: {
			shareTo: "Share to",
			saveImage: "Save Image",
			saving: "Saving…",
			saveSuccess: "Image saved",
			saveFailed: "Failed to save. Please try again.",
			copyLink: "Copy Link",
			copySuccess: "Link copied",
			copyFailed: "Failed to copy. Please try again.",
			defaultShareText: "Check out today's almanac!",
			needData: "Please wait for the almanac to finish loading before sharing",
			labels: {
				wuxing: "Wuxing",
				caiwei: "Wealth",
				xishen: "Joy God",
				shengxiao: "Zodiac",
			},
		},
		aria: {
			breadcrumb: "Breadcrumb",
			yi: "Yi",
			ji: "Ji",
			compass: "Compass",
			prevDay: "Previous day",
			nextDay: "Next day",
		},
		nav: {
			huangli: "Chinese Almanac",
			zeri: "Date Selection",
			xiangjie: "Detail",
			fortune: "Fortune",
		},
		load: {
			loading: "Loading...",
		},
		empty: {
			noData: "No data",
		},
		common: {
			cancel: "Cancel",
			confirm: "OK",
			yi: "Suitable",
			ji: "Taboo",
			yearSuffix: "{n}",
			monthSuffix: "{n}",
			daySuffix: "{n}",
			yearMonth: "{y}-{m}",
			age: "{n}",
			heidao: "Black Path",
			huangdao: "Yellow Path",
		},
		dayPanel: {
			prevDay: "Previous day",
			nextDay: "Next day",
			selectDate: "Select date",
			dir: {
				xi: "Happy event",
				cai: "Wealth",
				gui: "Expensive",
				sheng: "Generate",
			},
			labels: {
				todayWuxing: "Wu Xing",
				tiangan: "Heavenly Stems",
				dizhi: "Earthly Branches",
				nayin: "Na Yin",
				ershibaXiu: "Twenty-eight Mansions",
				shierShen: "Twelve gods",
				todayBazi: "Ba Zi",
				pengzu: "Pengzu Taboos",
				luckShengxiao: "Lucky Zodiac",
				todayTaishen: "Today's Taishen",
				wuhou: "Phenology",
				dailyLuckStar: "Daily Lucky Star",
				rilu: "Rilu",
				jinfujing: "Jinfujing",
			},
		},
		calendar: {
			goZeri: "Select a date",
			prevMonth: "Previous month",
			nextMonth: "Next month",
			backToday: "Back to today",
			ganzhiYear: "{gz} {animal}",
			weekdays: {
				sun: "Sun",
				mon: "Mon",
				tue: "Tue",
				wed: "Wed",
				thu: "Thu",
				fri: "Fri",
				sat: "Sat",
			},
		},
		detail: {
			title: "Almanac Details",
			titleWithDate: "{y}-{m}-{d} Details",
			yiJiFallback: "Yi & Ji",
			emptyYi: "Nothing suitable",
			emptyJi: "Nothing taboo",
			tabs: {
				yiJi: "Yi & Ji",
				chongSha: "Clash",
				jiSheng: "Auspicious",
				xiongShen: "Inauspicious",
				huangDao: "Huang/Hei Dao",
				siZhu: "Four Pillars",
				shengXiao: "Zodiac",
				wuXing: "Five Elements",
				taiShen: "Taishen",
				pengZu: "Pengzu",
				xingYao: "Stars",
			},
		},
		zeri: {
			title: "Date Selection",
			typeSelectTitle: "Choose auspicious day type",
			titleWithName: "{name} — Dates",
			countHintBefore: "About",
			countHintAfter: "suitable days for {name} in the next year",
			monthAuspicious: "{month} auspicious days for {name}:",
			monthDayUnit: "days",
			lunarPrefix: "Lunar",
			empty: "No suitable dates for {name}",
			chongPrefix: "Clash {animal}",
			jiShiPrefix: "Lucky hours: ",
		},
	},
};
